var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#0b6462;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.491,22.5h-.848V1.125A1.075,1.075,0,0,0,16.625,0H2.375A1.075,1.075,0,0,0,1.357,1.125V22.5H.509A.538.538,0,0,0,0,23.063V24H19v-.937A.538.538,0,0,0,18.491,22.5ZM5.429,3.563A.538.538,0,0,1,5.938,3h1.7a.538.538,0,0,1,.509.563V5.438A.538.538,0,0,1,7.634,6h-1.7a.538.538,0,0,1-.509-.562Zm0,4.5A.538.538,0,0,1,5.938,7.5h1.7a.538.538,0,0,1,.509.563V9.938a.538.538,0,0,1-.509.563h-1.7a.538.538,0,0,1-.509-.562ZM7.634,15h-1.7a.538.538,0,0,1-.509-.562V12.563A.538.538,0,0,1,5.938,12h1.7a.538.538,0,0,1,.509.563v1.875A.538.538,0,0,1,7.634,15Zm3.223,7.5H8.143V18.563A.538.538,0,0,1,8.652,18h1.7a.538.538,0,0,1,.509.563Zm2.714-8.062a.538.538,0,0,1-.509.563h-1.7a.538.538,0,0,1-.509-.562V12.563A.538.538,0,0,1,11.366,12h1.7a.538.538,0,0,1,.509.563Zm0-4.5a.538.538,0,0,1-.509.563h-1.7a.538.538,0,0,1-.509-.562V8.063a.538.538,0,0,1,.509-.562h1.7a.538.538,0,0,1,.509.563Zm0-4.5A.538.538,0,0,1,13.063,6h-1.7a.538.538,0,0,1-.509-.562V3.563A.538.538,0,0,1,11.366,3h1.7a.538.538,0,0,1,.509.563Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default __webpack_public_path__ + "static/media/project.40f6ec62c49991177ad468773a02a73d.svg";
export { ForwardRef as ReactComponent };